import axios from "axios";

class FileAPIService {
  async getFile(signedUrl: string): Promise<Blob> {
    const response = await axios.get(signedUrl, { responseType: "blob" });
    return response.data;
  }

  async putFile(file: File, signedUrl: string): Promise<void> {
    await axios.put(signedUrl, file, { headers: { "Content-Type": file.type } });
  }

  async deleteFile(signedUrl: string): Promise<void> {
    await axios.delete(signedUrl);
  }
}

export { FileAPIService };
